module.exports = __webpack_public_path__ + "img/frequency.0819bd63.png";